$ = require 'jquery'
Controller = require 'controller'
InstantSearchView = require 'views/search/instant-search-view'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
PopOver = require 'views/lib/pop-over'
Search = require 'views/search/search'
SearchState = require 'view-models/search-state'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class SearchInputView extends View

  constructor: ->
    @fSearchOpen = false

    # we want custom debounce intervals for these.
    @saveQueryDebounced = _.debounce(@saveQuery, 100)
    @openSearchResultsViewDebounced = _.debounce(@openSearchResultsView, 100)
    @autosuggestDebounced = _.debounce(@autosuggest, 100)

    UserInput.addHandler(@, { scope: 'search_box' })

    super

  initialize: ->
    @makeDebouncedMethods 'renderInputState'

    @listenTo SearchState,
      'change:query': @renderInputQuery

  events:
    'keydown .js-search-input': 'searchKeydown'
    'input .js-search-input': 'search'
    'click .js-search-input': (e) ->
      Util.stop(e)
      @openSearchResultsView()

    'focus .js-search-input': 'openSearchResultsView'

    'click .js-open-search-page': 'openSearchPage'

    # we want this to be instant or else the blur event takes place
    # and the input hides before the click (mouseup) is registered.
    'mousedown .js-search-close': 'clearSearch'
    'shortcut': 'shortcut'

  render: ->
    @$el.html(
      templates.fill(
        'header_search'
      )
    )

    @renderInputStateDebounced()
    @$('.js-search-input').val(SearchState.getQuery())

    @

  renderInputQuery: ->
    $searchInput = @$('.js-search-input')
    val = $searchInput.val()
    query = SearchState.getQuery()

    if $searchInput.length > 0 && val != query
      $searchInput.val(query)
      Util.setCaretAtEnd($searchInput)

    return

  renderInputState: ->
    isFocused = @fSearchOpen
    hasInputValue = @hasInputValue()

    @$('.js-search-input').toggleClass('header-search-input-wide focus', isFocused)

    @$('.js-search-icon, .js-close-icon, .js-open-button').toggleClass('header-search-icon-dark', isFocused)

    @$('.js-search-icon').toggleClass('hide', isFocused)
    @$('.js-close-icon').toggleClass('hide', !isFocused)
    @$('.js-open-button').toggleClass('hide', !isFocused)

    return

  hasInputValue: -> @$('.js-search-input').val()?.length > 0

  shortcut: (key) ->
    if key == Keys.ForwardSlash
      @focusInput()
      "Search"

  focusInput: ->
    $input = @$('.js-search-input')

    if $input.length # if input exists
      Util.setCaretAtEnd($input)

    return

  clearSearch: (e) ->
    Util.stop(e)
    PopOver.hide()
    @closeSearch()

    return

  closeSearch: ->
    @$('.js-search-input').val("").blur()
    SearchState.setQuery("")
    @fSearchOpen = false
    @renderInputStateDebounced()
    return

  searchKeydown: (e) ->
    key = Keyboard.getKey(e)
    @renderInputStateDebounced()

    isCaretAtEnd = e.target.selectionStart == e.target.selectionEnd == e.target.value.length
    if key in [Keys.Enter, Keys.Tab] || (key == Keys.ArrowRight && isCaretAtEnd)
      hasSuggestion = $('.js-select-suggestion.selected').length

      if hasSuggestion
        Util.stop(e)
        $('.js-select-suggestion.selected').click()

    else if key in [Keys.ArrowUp, Keys.ArrowDown]
      hasSuggestion = $('.js-select-suggestion.selected').length

      if hasSuggestion
        Util.stop(e)
        Util.navMenuList($('.js-search-suggestions-list'), '.js-select-suggestion', key)

    return

  search: (e) ->
    @autosuggestDebounced()
    @saveQueryDebounced()
    @openSearchResultsViewDebounced()

  autosuggest: (e) ->
    $input = @$('.js-search-input')
    term = Util.getWordFromCaret($input).str
    matchedKeywords = Search.findUniqueKeywords(term)
    query = SearchState.getQuery()
    Search.inputIndex = Util.getCaretPosition($input)

    # if the operator is already in the query, don't suggest it.
    newSuggestions = _.filter matchedKeywords, (keyword) ->
      re = Search.getSuggestionObjectContainingVariantOrKey(keyword).obj.containsRegex
      !re.test(query)

    SearchState.setSuggestions(newSuggestions)

    # do we need to search for member or board suggestions?
    foundSearch = false

    for key, sug of Search.getKeywordsWithSearchSuggest()
      re = sug.containsRegex

      if re.test(term)
        foundSearch = true

        types = sug.suggestionsSearchModelTypes
        SearchState.setSuggestionSearchModelTypes(types)

        newTerm = term.replace(/// ^#{key} ///, "")
        SearchState.setSuggestionSearchTerm(newTerm)

        return

    if !foundSearch
      SearchState.clearSuggestionSearchTerm()
      SearchState.clearSuggestionSearchModelTypes()

    return

  saveQuery: ->
    query = @$('.js-search-input').val()
    SearchState.setQuery(query)
    if /\/search/.test(location.pathname)
      Controller.navigate Controller.getSearchUrl(query), { replace: true }
    return

  getResultsView: -> @subview(InstantSearchView, null, null, 'headerSearchResultsView')

  openSearchResultsView: ->
    if !@fSearchOpen && !Controller.isOnSearchPage()
      @fSearchOpen = true
      $searchInput = @$('.js-search-input')

      $searchInput.focus()

      Util.setCaretAtEnd($searchInput)

      PopOver.show
        elem: $searchInput
        view: new InstantSearchView({ @model, @modelCache })
        elActive: $searchInput
        hidden: _.bind @closeSearch, @

    @fSearchOpen = true
    @renderInputStateDebounced()

    return

  openSearchPage: (e) ->
    Util.stop(e)
    query = SearchState.getQuery()
    PopOver.hide()
    Search.navigateToSearch(query, { trigger: true })
    track("Header", "Open Search Page")



// WEBPACK FOOTER //
// ./app/scripts/views/search/search-input-view.coffee